import revolutIcon from "src/assets/img/payment_vendors/revolut.webp";

export function InternetBankIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.99"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.42774 1.67017C6.73246 1.66431 10.0371 1.67017 13.3418 1.68774C14.2207 1.82861 14.8125 2.31494 15.1172 3.14673C15.1646 3.40199 15.1822 3.6598 15.1699 3.92017C16.3656 3.97624 17.1097 4.58564 17.4023 5.74829C17.4258 8.65455 17.4258 11.5608 17.4023 14.467C17.1697 15.4614 16.5545 16.0649 15.5566 16.2776C11.1738 16.301 6.79103 16.301 2.4082 16.2776C1.41037 16.0649 0.795133 15.4614 0.562501 14.467C0.539062 11.1624 0.539062 7.85767 0.562501 4.55298C0.891096 2.96463 1.84618 2.00369 3.42774 1.67017ZM3.88477 2.79517C6.8965 2.78931 9.90823 2.79517 12.9199 2.81274C13.6427 2.8383 14.0177 3.20744 14.0449 3.92017C10.9746 3.9143 7.90429 3.92017 4.83399 3.93774C4.51821 4.095 4.40687 4.34696 4.5 4.6936C4.56444 4.85181 4.67578 4.96315 4.83399 5.02759C8.2793 5.0393 11.7246 5.05104 15.1699 5.06274C15.7212 5.11235 16.0786 5.39944 16.2422 5.92407C16.2924 6.75489 16.3099 7.58693 16.2949 8.42017C15.3431 8.24628 14.6341 8.57443 14.168 9.40454C13.8396 10.4005 14.1267 11.1563 15.0293 11.6721C15.1444 11.7144 15.2616 11.7495 15.3809 11.7776C15.6853 11.7952 15.99 11.801 16.2949 11.7952C16.3008 12.5453 16.2949 13.2952 16.2773 14.0452C16.2277 14.5965 15.9407 14.9539 15.416 15.1174C11.2099 15.1755 7.00284 15.1873 2.79492 15.1526C2.12109 15.0881 1.75195 14.719 1.6875 14.0452C1.65335 10.9156 1.66507 7.78672 1.72266 4.65845C2.00653 3.52466 2.72723 2.90356 3.88477 2.79517ZM15.7324 9.54517C15.9199 9.54517 16.1074 9.54517 16.2949 9.54517C16.2949 9.92018 16.2949 10.2952 16.2949 10.6702C16.0466 10.6803 15.8005 10.6627 15.5566 10.6174C15.2623 10.48 15.151 10.2515 15.2227 9.93189C15.3218 9.70418 15.4918 9.57526 15.7324 9.54517Z"
        fill="black"
      />
      <path
        opacity="0.96"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.41992 7.2952C9.93252 7.15662 11.2157 7.62539 12.2695 8.70145C12.4258 9.07843 12.3262 9.36552 11.9707 9.56278C11.7552 9.60729 11.5559 9.57213 11.373 9.45731C10.3131 8.45311 9.09432 8.19531 7.7168 8.68387C7.25168 8.88697 6.84151 9.16822 6.48633 9.52762C5.93255 9.68772 5.64543 9.48266 5.625 8.91239C5.63766 8.83828 5.66111 8.76797 5.69531 8.70145C6.43795 7.91117 7.34618 7.44244 8.41992 7.2952Z"
        fill="black"
      />
      <path
        opacity="0.955"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.7366 9.54482C9.48244 9.49841 10.1211 9.73276 10.6526 10.2479C10.8678 10.7551 10.7096 11.0715 10.178 11.1972C10.054 11.1759 9.9368 11.1349 9.82645 11.0741C9.45393 10.7086 9.02035 10.6148 8.52567 10.7929C8.3869 10.873 8.25802 10.9668 8.13895 11.0741C7.7569 11.2696 7.45808 11.1817 7.24246 10.8104C7.20411 10.6137 7.22756 10.4262 7.31278 10.2479C7.70807 9.84814 8.18268 9.61376 8.7366 9.54482Z"
        fill="black"
      />
      <path
        opacity="0.937"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.77116 11.7952C9.44891 11.7639 9.67742 12.0685 9.45671 12.7092C9.21255 12.9402 8.93717 12.9812 8.63054 12.8323C8.3996 12.5881 8.35857 12.3127 8.50749 12.0061C8.58181 11.9139 8.6697 11.8436 8.77116 11.7952Z"
        fill="black"
      />
    </svg>
  );
}

export function RevolutIcon() {
  return <img height="18" alt="revolut" src={revolutIcon} />;
}

export function CardIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3874_5088)">
        <path
          opacity="0.989"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.9824 3.91992C17.9824 7.29492 17.9824 10.6699 17.9824 14.0449C17.7994 14.6319 17.4009 14.9776 16.7871 15.082C11.584 15.1055 6.38086 15.1055 1.17773 15.082C0.56392 14.9776 0.165483 14.6319 -0.0175781 14.0449C-0.0175781 10.6699 -0.0175781 7.29492 -0.0175781 3.91992C0.165483 3.33294 0.56392 2.98724 1.17773 2.88281C6.38086 2.85937 11.584 2.85937 16.7871 2.88281C17.4009 2.98724 17.7994 3.33294 17.9824 3.91992ZM11.584 5.18555C13.0723 5.17968 14.5606 5.18555 16.0488 5.20313C16.293 5.34544 16.3458 5.5388 16.207 5.7832C16.1437 5.84708 16.0676 5.88811 15.9785 5.90625C14.5254 5.9297 13.0723 5.9297 11.6191 5.90625C11.2569 5.68287 11.2451 5.44261 11.584 5.18555ZM1.98633 6.55664C2.80672 6.55077 3.62704 6.55664 4.44727 6.57422C4.5681 6.61307 4.65599 6.68925 4.71094 6.80274C4.74518 7.47387 4.73347 8.14184 4.67578 8.80664C4.62154 8.87266 4.55709 8.9254 4.48242 8.96484C3.63867 8.98829 2.79492 8.98829 1.95117 8.96484C1.81641 8.92382 1.72852 8.83593 1.6875 8.70117C1.66406 8.09181 1.66406 7.48241 1.6875 6.87305C1.72319 6.70268 1.8228 6.59721 1.98633 6.55664ZM1.91602 10.8457C2.5958 10.8398 3.27549 10.8457 3.95508 10.8633C4.20124 11.0041 4.25398 11.1974 4.11328 11.4434C4.05777 11.4975 3.99329 11.5386 3.91992 11.5664C3.26367 11.5899 2.60742 11.5899 1.95117 11.5664C1.58934 11.3446 1.57762 11.1044 1.91602 10.8457ZM5.39648 10.8457C6.07627 10.8398 6.75598 10.8457 7.43555 10.8633C7.67974 11.0056 7.73248 11.199 7.59375 11.4434C7.53824 11.4975 7.47376 11.5386 7.40039 11.5664C6.74413 11.5899 6.0879 11.5899 5.43164 11.5664C5.06936 11.343 5.05765 11.1028 5.39648 10.8457ZM8.87695 10.8457C9.54503 10.8398 10.213 10.8457 10.8809 10.8633C11.0499 10.9201 11.1437 11.0373 11.1621 11.2148C11.1294 11.3972 11.024 11.5144 10.8457 11.5664C10.2012 11.5899 9.55663 11.5899 8.91211 11.5664C8.64742 11.4647 8.57127 11.283 8.68359 11.0215C8.74441 10.9546 8.80886 10.896 8.87695 10.8457ZM12.3574 10.8457C13.0255 10.8398 13.6935 10.8457 14.3613 10.8633C14.5778 10.9516 14.654 11.1098 14.5898 11.3379C14.5341 11.4524 14.4462 11.5285 14.3262 11.5664C13.6817 11.5899 13.0371 11.5899 12.3926 11.5664C12.1012 11.4342 12.0368 11.2291 12.1992 10.9512C12.2573 10.9196 12.31 10.8844 12.3574 10.8457ZM1.95117 12.5684C4.1426 12.5625 6.33403 12.5684 8.52539 12.5859C8.77085 12.6989 8.83529 12.8805 8.71875 13.1309C8.6612 13.2121 8.58502 13.2648 8.49023 13.2891C6.31055 13.3125 4.13086 13.3125 1.95117 13.2891C1.68002 13.1631 1.61557 12.9697 1.75781 12.709C1.81054 12.6398 1.87499 12.5929 1.95117 12.5684Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_3874_5088">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function BankTransferIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-building-bank">
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 21l18 0" />
      <path d="M3 10l18 0" />
      <path d="M5 6l7 -3l7 3" />
      <path d="M4 10l0 11" />
      <path d="M20 10l0 11" />
      <path d="M8 14l0 3" />
      <path d="M12 14l0 3" />
      <path d="M16 14l0 3" />
    </svg>
  );
}

export function OfflinePaymentIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-file-invoice">
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M14 3v4a1 1 0 0 0 1 1h4" />
      <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
      <path d="M9 7l1 0" />
      <path d="M9 13l6 0" />
      <path d="M13 17l2 0" />
    </svg>
  );
}
